import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import { useSelector } from 'react-redux';
import { makeGetSeoTextsBlocksItems } from 'selectors';
import { useSelectorProps } from 'hooks';
import InnerHTML from 'components/InnerHTML';
import { Wrapper, Blocks } from './styles';
var getSeoTextsBlocksItems = makeGetSeoTextsBlocksItems();

function SeoTextsBlocks() {
  var selectorProps = useSelectorProps();
  var seoTextsBlocksItems = useSelector(function (state) {
    return getSeoTextsBlocksItems(state, selectorProps);
  });
  return seoTextsBlocksItems.length ? /*#__PURE__*/_jsx(Wrapper, {}, void 0, /*#__PURE__*/_jsx(Blocks, {}, void 0, seoTextsBlocksItems.map(function (_ref) {
    var id = _ref.id,
        description = _ref.description;
    return /*#__PURE__*/_jsx(InnerHTML, {
      html: description
    }, id);
  }))) : null;
}

export default SeoTextsBlocks;